import React, { Fragment, useEffect, useState } from "react";
import {
  ViedocButtonElement,
  ViedocCheckboxElement,
  ViedocDialogElement,
  ViedocMenuItemElement,
  ViedocRadioElement,
  ViedocSelectElement,
  ViedocTextareaElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as templateActions from "../../../../store/actions/templateActions";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import Loader from "../../shared/Loader/Loader";
import _ from "underscore";
import LocationLevelSetting from "./LocationLevelSetting";
import APP_CONST from "../../../shared/constants";

const EditArtifactPopUp = ({ artifactDetails, setIsEditArtifactVisible }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    viewLoading,
    datingConventionList,
    viewDialog,
    artifactFail,
    isEditLoading,
    tmfStructureData,
    zoneData,
  } = useSelector((store) => store.template);

  const {
    classification,
    countrylevelsetting,
    detail,
    sitelevelsetting,
    triallevelsetting,
    filename,
    sharing,
  } = viewDialog.artifactData;

  useEffect(() => {
    !_.isEmpty(artifactFail) && setShowToaster(true);
  }, [artifactFail]);

  useEffect(() => {
    setArtifactName(classification?.artifactname);
    setIsArtifactLinkShared(classification?.isartifactlinkshared);
    setDefinition(classification?.definition);
    setUniqueId(
      classification?.uniqueidnumber === "0"
        ? ""
        : classification?.uniqueidnumber
    );
    setSelectedDatingConvention(detail?.datingconvention);

    setSubArtifact(
      classification?.subartifacts
        ? !_.isEmpty(classification?.subartifacts[0])
          ? classification?.subartifacts[0]
          : ""
        : ""
    );
    setAddSubartifact(
      classification?.subartifacts ? classification?.subartifacts.slice(1) : []
    );
    setIsSponsor(
      !_.isEmpty(classification?.possession)
        ? classification?.possession.includes(APP_CONST.TEXT_SPONSOR)
        : false
    );
    setIsInvestigator(
      !_.isEmpty(classification?.possession)
        ? classification?.possession.includes(APP_CONST.TEXT_INVESTIGATOR)
        : false
    );

    setDetailsValue(detail?.fileformats[0]);
    setBlindedData(detail?.blindeddata);
    setPrivacyData(detail?.privaydata);
    setFileFormats(
      detail?.fileformats[0] === "*" ? "" : detail?.fileformats[0]
    );
    setAddSupportedFilesTypes(detail?.fileformats.slice(1) || []);

    setTrialMilestone(triallevelsetting?.milestone);
    setCountryMilestone(countrylevelsetting?.milestone);
    setSiteMilestone(sitelevelsetting?.milestone);

    setTrialDocument(triallevelsetting?.document);
    setCountryDocument(countrylevelsetting?.document);
    setSiteDocument(sitelevelsetting?.document);
    setTrialRolesAndAccessPayload(
      createRolesAndAccessPayload(triallevelsetting, "trial")
    );
    setCountryRolesAndAccessPayload(
      createRolesAndAccessPayload(countrylevelsetting, "country")
    );
    setSiteRolesAndAccessPayload(
      createRolesAndAccessPayload(sitelevelsetting, "site")
    );

    setClinicalUserChecked(sharing?.clinicaluser?.enable || false);
    setViedocMeUserChecked(sharing?.subjectuser?.enable || false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    classification,
    detail,
    triallevelsetting,
    countrylevelsetting,
    sitelevelsetting,
    sharing,
  ]);

  const [initialLoad, setInitialLoad] = useState(true);
  const [isTouched, setIsTouched] = useState(false);
  const [artifactName, setArtifactName] = useState(
    classification?.artifactname
  );

  const [showToaster, setShowToaster] = useState(false);
  const [showWarnings, setShowWarnings] = useState(false);

  const [isArtifactLinkShared, setIsArtifactLinkShared] = useState(
    classification?.isartifactlinkshared || false
  );
  const [definition, setDefinition] = useState(classification?.definition);
  const [uniqueId, setUniqueId] = useState(
    classification?.uniqueidnumber === "0" ? "" : classification?.uniqueidnumber
  );

  const countryLevelDocument = {
    isRequired: countrylevelsetting?.document === APP_CONST.TEXT_REQUIRED,
    isOptional: countrylevelsetting?.document === APP_CONST.TEXT_OPTIONAL,
    isNotPermitted: countrylevelsetting?.document === APP_CONST.TEXT_NEW,
  };
  const trialLevelDocument = {
    isRequired: triallevelsetting?.document === APP_CONST.TEXT_REQUIRED,
    isOptional: triallevelsetting?.document === APP_CONST.TEXT_OPTIONAL,
    isNotPermitted: triallevelsetting?.document === APP_CONST.TEXT_NEW,
  };
  const siteLevelDocument = {
    isRequired: sitelevelsetting?.document === APP_CONST.TEXT_REQUIRED,
    isOptional: sitelevelsetting?.document === APP_CONST.TEXT_OPTIONAL,
    isNotPermitted: sitelevelsetting?.document === APP_CONST.TEXT_NEW,
  };

  const [isSponsor, setIsSponsor] = useState(
    classification?.possession
      ? classification?.possession.includes(APP_CONST.TEXT_SPONSOR)
      : false
  );
  const [isInvestigator, setIsInvestigator] = useState(
    classification?.possession
      ? classification?.possession.includes(APP_CONST.TEXT_INVESTIGATOR)
      : false
  );

  const [selectedDatingConvention, setSelectedDatingConvention] = useState(
    detail?.datingconvention
  );
  const [newDatingConvention, setNewDatingConvention] = useState();

  const [detailsValue, setDetailsValue] = useState(detail?.fileformats[0]);
  const [blindedData, setBlindedData] = useState(detail?.blindeddata);
  const [privacyData, setPrivacyData] = useState(detail?.privaydata);
  const [clinicalUserChecked, setClinicalUserChecked] = useState(
    sharing?.clinicaluser?.enable || false
  );
  const [viedocMeUserChecked, setViedocMeUserChecked] = useState(
    sharing?.subjectuser?.enable || false
  );
  const [subArtifact, setSubArtifact] = useState(
    classification?.subartifacts ? classification?.subartifacts[0] : ""
  );

  const [addSubartifact, setAddSubartifact] = useState(
    classification?.subartifacts ? classification?.subartifacts.slice(1) : []
  );
  const [fileFormats, setFileFormats] = useState(
    detail?.fileformats[0] === "*" ? "" : detail?.fileformats[0]
  );

  const [addSupportedFilesTypes, setAddSupportedFilesTypes] = useState(
    detail?.fileformats.slice(1) || []
  );

  let subArtifactPayload = [subArtifact, ...addSubartifact];

  const [trialMilestone, setTrialMilestone] = useState(
    triallevelsetting?.milestone
  );
  const [countryMilestone, setCountryMilestone] = useState(
    countrylevelsetting?.milestone
  );
  const [siteMilestone, setSiteMilestone] = useState(
    sitelevelsetting?.milestone
  );

  const [trialDocument, setTrialDocument] = useState(
    triallevelsetting?.document
  );
  const [countryDocument, setCountryDocument] = useState(
    countrylevelsetting?.document
  );
  const [siteDocument, setSiteDocument] = useState(sitelevelsetting?.document);

  const [trialRolesAndAccessPayload, setTrialRolesAndAccessPayload] = useState(
    createRolesAndAccessPayload(triallevelsetting, "trial")
  );
  const [countryRolesAndAccessPayload, setCountryRolesAndAccessPayload] =
    useState(createRolesAndAccessPayload(countrylevelsetting, "country"));
  const [siteRolesAndAccessPayload, setSiteRolesAndAccessPayload] = useState(
    createRolesAndAccessPayload(sitelevelsetting, "site")
  );

  function createRolesAndAccessPayload(settings, type) {
    const userScope =
      type === "trial" ? "Study" : type === "country" ? "Country" : "Site";
    return [
      {
        userRole: "SITESTAFF",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SITESTAFF")
        ).access[0],
      },
      {
        userRole: "SPONSOR-STUDY",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SPONSOR-STUDY")
        ).access[0],
      },
      {
        userRole: "SPONSOR-COUNTRY",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SPONSOR-COUNTRY")
        ).access[0],
      },
      {
        userRole: "SPONSOR-SITE",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SPONSOR-SITE")
        ).access[0],
      },
      {
        userRole: "SPONSOR-REVIEW",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SPONSOR-REVIEW")
        ).access[0],
      },
      {
        userRole: "SPONSOR-DM",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SPONSOR-DM")
        ).access[0],
      },
      {
        userRole: "SPONSOR-UNBLINDED",
        userScope: userScope,
        access: settings?.rolesaccesses.find((role) =>
          role.name.includes("Role SPONSOR-UNBLINDED")
        ).access[0],
      },
    ];
  }

  useEffect(() => {
    !_.isEmpty(artifactFail) && setShowToaster(true);
    if (_.isEmpty(artifactFail) && !isEditLoading && !initialLoad) {
      setIsEditArtifactVisible(false);
      setInitialLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artifactFail, isEditLoading]);

  useEffect(() => {
    if (
      !_.isEmpty(artifactName) &&
      !_.isEmpty(definition) &&
      !_.isEmpty(fileFormats)
    ) {
      setShowToaster(false);
      setShowWarnings(false);
    }
  }, [artifactName, definition, fileFormats]);

  useEffect(() => {
    if (siteDocument !== "Not permitted" && !_.isEmpty(siteMilestone)) {
      setShowToaster(false);
      setShowWarnings(false);
    } else if (
      trialDocument !== "Not permitted" &&
      !_.isEmpty(trialMilestone)
    ) {
      setShowToaster(false);
      setShowWarnings(false);
    } else if (
      countryDocument !== "Not permitted" &&
      !_.isEmpty(countryMilestone)
    ) {
      setShowToaster(false);
      setShowWarnings(false);
    }
  }, [
    countryDocument,
    countryMilestone,
    siteDocument,
    siteMilestone,
    trialDocument,
    trialMilestone,
  ]);

  // eslint-disable-next-line no-sparse-arrays
  const EditArtifactFormValidation = [
    {
      initialValue: classification?.artifactname,
      selectedValue: artifactName,
    },
    {
      initialValue: classification?.definition,
      selectedValue: definition,
    },
    {
      initialValue:
        classification?.uniqueidnumber === "0"
          ? ""
          : classification?.uniqueidnumber,
      selectedValue: uniqueId,
    },
    {
      initialValue: classification?.subartifacts
        ? classification?.subartifacts[0]
        : "",
      selectedValue: subArtifact,
    },
    {
      initialValue: !_.isEmpty(classification?.possession)
        ? classification?.possession.includes("Sponsor")
        : false,
      selectedValue: isSponsor,
    },
    {
      initialValue: !_.isEmpty(classification?.possession)
        ? classification?.possession.includes("Investigator")
        : false,
      selectedValue: isInvestigator,
    },
    {
      initialValue: classification?.subartifacts
        ? classification?.subartifacts.slice(1)
        : [],
      selectedValue: addSubartifact?.filter((item) => item?.length),
    },
    ,
    {
      initialValue: triallevelsetting?.document,
      selectedValue: trialDocument,
    },
    {
      initialValue: countrylevelsetting?.document,
      selectedValue: countryDocument,
    },
    {
      initialValue: sitelevelsetting?.document,
      selectedValue: siteDocument,
    },
    {
      initialValue: createRolesAndAccessPayload(triallevelsetting, "trial"),
      selectedValue:
        triallevelsetting?.document === APP_CONST.TEXT_NOT_PERMITTED
          ? createRolesAndAccessPayload(triallevelsetting, "trial")
          : trialRolesAndAccessPayload,
    },
    {
      initialValue: createRolesAndAccessPayload(countrylevelsetting, "country"),
      selectedValue:
        countrylevelsetting?.document === APP_CONST.TEXT_NOT_PERMITTED
          ? createRolesAndAccessPayload(countrylevelsetting, "country")
          : countryRolesAndAccessPayload,
    },
    {
      initialValue: createRolesAndAccessPayload(sitelevelsetting, "site"),
      selectedValue:
        sitelevelsetting?.document === APP_CONST.TEXT_NOT_PERMITTED
          ? createRolesAndAccessPayload(sitelevelsetting, "site")
          : siteRolesAndAccessPayload,
    },
    {
      initialValue: triallevelsetting?.milestone,
      selectedValue:
        triallevelsetting?.document === APP_CONST.TEXT_NOT_PERMITTED
          ? triallevelsetting?.milestone
          : trialMilestone,
    },
    {
      initialValue: countrylevelsetting?.milestone,
      selectedValue:
        countrylevelsetting?.document === APP_CONST.TEXT_NOT_PERMITTED
          ? countrylevelsetting?.milestone
          : countryMilestone,
    },
    {
      initialValue: sitelevelsetting?.milestone,
      selectedValue:
        sitelevelsetting?.document === APP_CONST.TEXT_NOT_PERMITTED
          ? sitelevelsetting?.milestone
          : siteMilestone,
    },
    {
      initialValue: sharing?.clinicaluser?.enable || false,
      selectedValue: clinicalUserChecked,
    },
    {
      initialValue: sharing?.subjectuser?.enable || false,
      selectedValue: viedocMeUserChecked,
    },
    {
      initialValue: detail?.blindeddata,
      selectedValue: blindedData,
    },
    {
      initialValue: detail?.privaydata,
      selectedValue: privacyData,
    },
    {
      initialValue: detail?.datingconvention,
      selectedValue: selectedDatingConvention,
    },
    {
      initialValue: detail?.fileformats[0],
      selectedValue: detailsValue,
    },
    {
      initialValue: detail?.fileformats.slice(1) || [],
      selectedValue: addSupportedFilesTypes,
    },
    {
      initialValue:
        detail?.fileformats[0] === "*" ? "" : detail?.fileformats[0],
      selectedValue: fileFormats,
    },
  ];

  const editFormValidation = () => {
    const getArtifactFormValue = (formState) => {
      const formValue = EditArtifactFormValidation?.map((formValue) => {
        let formValueObject = {
          formValue: formValue[formState],
        };
        return formValueObject;
      });
      return formValue;
    };
    const artifactInitialFormValue = getArtifactFormValue("initialValue");
    const artifactSelectedFormValue = getArtifactFormValue("selectedValue");
    if (
      JSON?.stringify(artifactInitialFormValue) ===
      JSON?.stringify(artifactSelectedFormValue)
    ) {
      setIsTouched(false);
    } else {
      setIsTouched(true);
    }
  };

  useEffect(() => {
    editFormValidation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    artifactName,
    definition,
    uniqueId,
    subArtifact,
    isSponsor,
    isInvestigator,
    addSubartifact,
    trialDocument,
    countryDocument,
    siteDocument,
    trialRolesAndAccessPayload,
    countryRolesAndAccessPayload,
    siteRolesAndAccessPayload,
    trialMilestone,
    countryMilestone,
    siteMilestone,
    clinicalUserChecked,
    viedocMeUserChecked,
    blindedData,
    privacyData,
    selectedDatingConvention,
    detailsValue,
    addSupportedFilesTypes,
    fileFormats,
  ]);

  const sendRolesAndAccessData = (data, type) => {
    switch (type) {
      case "trial":
        setTrialRolesAndAccessPayload(data);
        break;
      case "country":
        setCountryRolesAndAccessPayload(data);
        break;
      case "site":
        setSiteRolesAndAccessPayload(data);
        break;
      default:
        break;
    }
  };
  const sendDocument = (data, type) => {
    switch (type) {
      case "trial":
        setTrialDocument(data);
        break;
      case "country":
        setCountryDocument(data);
        break;
      case "site":
        setSiteDocument(data);
        break;
      default:
        break;
    }
  };

  const sendMilestone = (data, type) => {
    switch (type) {
      case "trial":
        setTrialMilestone(data);
        break;
      case "country":
        setCountryMilestone(data);
        break;
      case "site":
        setSiteMilestone(data);
        break;
      default:
        break;
    }
  };

  const onHide = () => {
    setIsEditArtifactVisible(false);
    dispatch(templateActions.clearArtifactError());
  };

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };

  const classificationArray = [
    {
      id: 1,
      label: t("TMF.TEXT_ZONENO"),
      value: artifactDetails.zoneId,
      class: "disabled_input",
      isDisabled: true,
    },
    {
      id: 2,
      label: t("DETAILPAGE.LABEL_ZONENAME"),
      value: artifactDetails.zoneName,
      class: "disabled_input w-450",
      isDisabled: true,
      isRequired: true,
    },
    {
      id: 3,
      label: t("TMF.TEXT_SECTIONNO"),
      value: artifactDetails.sectionId,
      class: "disabled_input",
      isDisabled: true,
    },
    {
      id: 4,
      label: t("TMF.TEXT_SECTIONNAME"),
      value: artifactDetails.sectionName,
      class: "disabled_input w-450",
      isDisabled: true,
      isRequired: true,
    },
    {
      id: 5,
      label: t("ADMIN.ADMINTAB_ARTIFACT"),
      value: classification?.artifactid,
      class: "disabled_input",
      isDisabled: true,
    },
  ];

  const tmfSideArray = [
    { id: 1, checkedValue: isSponsor, label: t("TMF.FORMLABEL_SPONSOR") },
    {
      id: 2,
      checkedValue: isInvestigator,
      label: t("ADMIN.FORMLABEL_INVESTIGATOR"),
    },
  ];

  const sharingSectionArray = [
    {
      id: 1,
      checkLabel: t("TMF.TEXT_VIEDOCCLINICALUSERS"),
      name: "clinicalUser",
      checked: clinicalUserChecked,
    },
    {
      id: 2,
      checkLabel: t("ADMIN.ADMINTAB_VIEDOCMEUSERS"),
      name: "viedocMeUser",
      checked: viedocMeUserChecked,
    },
  ];

  function onChangeFieldHandler(event, location, index) {
    switch (location) {
      case t("ADMIN.ADMINTAB_ARTIFACTNAME"):
        setArtifactName(event.target.value);
        break;

      case t("ADMIN.ADMINTAB_SUBARTIFACTS"):
        setSubArtifact(event.target.value);
        break;

      default:
        const inputValue = [...addSubartifact];
        inputValue[index] = event.target.value;
        setAddSubartifact(inputValue);
    }
  }

  const addSubArtifactHandler = () => {
    const newSubArtifactsList = [...addSubartifact, []];
    setAddSubartifact(newSubArtifactsList);
  };

  const removeSubartifactHandler = (index) => {
    const deleteValue = [...addSubartifact];
    deleteValue.splice(index, 1);
    setAddSubartifact(deleteValue);
  };

  const getIsRequired = (fieldLabel, fieldValue) => {
    if (
      showWarnings &&
      _.isEmpty(fieldValue) &&
      fieldLabel === t("ADMIN.ADMINTAB_ARTIFACTNAME")
    ) {
      return true;
    } else if (showWarnings && _.isEmpty(fieldValue) && fieldLabel === null) {
      return true;
    } else {
      return null;
    }
  };

  function renderSubArtifactsBlock(
    fieldLabel,
    fieldValue,
    isRequired,
    isIconVisible,
    isRemoveIcon,
    index
  ) {
    return (
      <Fragment key={index}>
        <div className="d-flex pad-5 align-center ">
          <div className="w-25 text-right pr-15 gray-60 fw-400">
            {fieldLabel}
            {isRequired ? spanFunc() : null}
          </div>
          <viedoc-textfield
            class={
              fieldLabel === t("ADMIN.ADMINTAB_ARTIFACTNAME") &&
              artifactFail.includes("existing artifact")
                ? "disabled_input w-365 required-warning"
                : "disabled_input w-365"
            }
            size="small"
            variant="outline"
            required={getIsRequired(fieldLabel, fieldValue)}
          >
            <input
              type="text"
              value={fieldValue}
              onChange={(e) => onChangeFieldHandler(e, fieldLabel, index)}
            />
          </viedoc-textfield>

          {isIconVisible && (
            <div className="icon-holder">
              {isRemoveIcon ? (
                <viedoc-icon
                  title={t("ADMIN.TEXT_REMOVE")}
                  name="remove"
                  onClick={() => removeSubartifactHandler(index)}
                />
              ) : (
                <viedoc-icon
                  title={t("ADMIN.TEXT_ADD")}
                  name="add"
                  onClick={() => addSubArtifactHandler()}
                />
              )}
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  function tmfSideCheckboxHandler(location) {
    switch (location) {
      case t("TMF.FORMLABEL_SPONSOR"):
        setIsSponsor((prevState) => !prevState);
        break;
      case t("ADMIN.FORMLABEL_INVESTIGATOR"):
        setIsInvestigator((prevState) => !prevState);
        break;
      default:
        break;
    }
  }

  const renderClassificationSection = () => {
    return (
      <section className="view-artifact-block ff-vmg">
        <article className="sem-pri-color">
          {t("ADMIN.TEXT_CLASSIFICATIONLBL")}
        </article>
        <aside className="d-flex flex-dir-col">
          <div className="pt-10">
            {classificationArray.map((classification) => (
              <div
                className="d-flex pad-5 align-center"
                key={classification.id}
              >
                <div className="w-25 text-right pr-15 gray-60 fw-400">
                  {classification.label}
                  {classification.isRequired ? spanFunc() : null}
                </div>
                <viedoc-textfield
                  class={classification.class}
                  size="small"
                  variant="outline"
                >
                  <input
                    type="text"
                    disabled={classification.isDisabled}
                    value={classification.value}
                  />
                </viedoc-textfield>
              </div>
            ))}
            {renderSubArtifactsBlock(
              t("ADMIN.ADMINTAB_ARTIFACTNAME"),
              artifactName,
              true,
              false,
              false,
              false,
              -1
            )}
            <div className="d-flex pt-0 pb-5">
              <div className="w-25 text-right pr-15 pt-20 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_DEFINITION")}
                {spanFunc()}
              </div>
              <ViedocTextareaElement
                placeholder="Text here"
                value={definition}
                rows={3}
                onChange={(e) => {
                  setDefinition(e.target.value);
                }}
                class={
                  showWarnings && _.isEmpty(definition)
                    ? "definition-area warning"
                    : "definition-area"
                }
              />
            </div>
            <div className="d-flex pad-5 align-center">
              <div className="w-25 text-right pr-15 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_UNIQUEID")}
              </div>
              <viedoc-textfield
                class={
                  artifactFail.includes("unique Id")
                    ? "disabled_input w-450 required-warning"
                    : "disabled_input w-450"
                }
                size="small"
                variant="outline"
              >
                <input
                  type="text"
                  value={uniqueId}
                  onChange={(e) => {
                    setUniqueId(e.target.value);
                  }}
                />
              </viedoc-textfield>
            </div>

            {renderSubArtifactsBlock(
              t("ADMIN.ADMINTAB_SUBARTIFACTS"),
              subArtifact,
              false,
              true,
              false,
              null
            )}

            {addSubartifact.map((data, index) => {
              return renderSubArtifactsBlock(
                null,
                data,
                false,
                true,
                true,
                index
              );
            })}
            <div className="d-flex pad-5 align-center">
              <div className="w-25 text-right pr-7 gray-60 fw-400">
                {t("ADMIN.TEXT_TMFSIDE")}
              </div>
              {tmfSideArray.map((tmf) => (
                <ViedocCheckboxElement
                  key={tmf.id}
                  class="pl-10 tmfside-checkbox"
                  checked={tmf.checkedValue}
                  onChange={() => tmfSideCheckboxHandler(tmf.label)}
                >
                  {tmf.label}
                </ViedocCheckboxElement>
              ))}
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const detailsRadioHandler = (location, type) => {
    switch (type) {
      case "Details":
        if (location === "Standard") {
          setDetailsValue("*");
          setFileFormats("");
          setAddSupportedFilesTypes([]);
        } else {
          setDetailsValue(addSupportedFilesTypes);
        }
        break;
      case "Blinded data":
        setBlindedData(location.toUpperCase());
        break;
      case "Privacy data":
        setPrivacyData(location.toUpperCase());
        break;
      default:
        break;
    }
  };

  const addSupportedFileshandler = () => {
    setAddSupportedFilesTypes([...addSupportedFilesTypes, []]);
  };

  const addFileTypesHandler = (event, index) => {
    const inputData = [...addSupportedFilesTypes];
    inputData[index] = event.target.value;
    setAddSupportedFilesTypes(inputData);
  };

  const removeFileTypeshandler = (index) => {
    const deleteValue = [...addSupportedFilesTypes];
    deleteValue.splice(index, 1);
    setAddSupportedFilesTypes(deleteValue);
  };

  function sharingCheckboxHandler(from, e) {
    switch (from) {
      case "clinicalUser":
        setClinicalUserChecked(e.target.checked);
        return;
      case "viedocMeUser":
        setViedocMeUserChecked(e.target.checked);
        return;
      default:
        break;
    }
  }

  const renderSharingSection = () => {
    return (
      <section className="view-artifact-block ff-vmg edit-structure-popup">
        <article className="sem-pri-color">
          {t("TMF.TEXT_DOCFILESHARING")}
        </article>
        <aside className="d-flex flex-dir-col edit-structure-detail">
          <div className="pt-10">
            <div className="d-flex pad-10 align-center">
              <div className="w-25 text-right pr-10 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_ENABLEFOR")}
              </div>
              {sharingSectionArray.map((sharing) => (
                <div className="d-flex gap-20 f14" key={sharing.id}>
                  <ViedocCheckboxElement
                    class={`tmfside-checkbox ${
                      sharing.id === 2 ? "pl-10" : ""
                    }`}
                    size="small"
                    checked={sharing.checked}
                    onChange={(e) => {
                      sharingCheckboxHandler(sharing.name, e);
                    }}
                  >
                    {sharing.checkLabel}
                  </ViedocCheckboxElement>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const renderDetailsSection = () => {
    return (
      <section className="view-artifact-block ff-vmg edit-structure-popup">
        <article className="sem-pri-color">
          {t("ADMIN.ADMINTAB_DETAILS")}
        </article>
        <aside className="d-flex flex-dir-col edit-structure-detail">
          <div className="pt-10">
            {detailsSectionArray.map((details) => (
              <Fragment key={details.id}>
                <div className="d-flex pad-10 align-center">
                  <div className="w-25 text-right pr-10 gray-60 fw-400">
                    {details.mainLabel}
                    {spanFunc()}
                  </div>
                  <div className="d-flex gap-20 f14">
                    <ViedocRadioElement
                      class="tmfside-checkbox"
                      checked={details.checked1}
                      onChange={() =>
                        detailsRadioHandler(details.location1, details.type)
                      }
                    >
                      {details.radioLabel1}
                    </ViedocRadioElement>

                    <ViedocRadioElement
                      class="tmfside-checkbox"
                      checked={details.checked2}
                      onChange={() =>
                        detailsRadioHandler(details.location2, details.type)
                      }
                    >
                      {details.radioLabel2}
                    </ViedocRadioElement>
                  </div>
                </div>
                {details.type === "Details" && detailsValue !== "*" && (
                  <div className="icon-holder ml-210 w-450 pad-5 d-flex supported-files">
                    <viedoc-textfield
                      size="small"
                      variant="outline"
                      class={
                        showWarnings && _.isEmpty(fileFormats) ? "warning" : ""
                      }
                    >
                      <input
                        type="text"
                        value={fileFormats}
                        onChange={(e) => {
                          setFileFormats(e.target.value);
                        }}
                      />
                    </viedoc-textfield>
                    <viedoc-icon
                      title={t("ADMIN.TEXT_ADD")}
                      name="add"
                      onClick={() => addSupportedFileshandler()}
                    />
                    {addSupportedFilesTypes.map((block, index) => {
                      return (
                        <div
                          className="icon-holder ml-10 w-80 d-flex supported-files"
                          key={index}
                        >
                          <viedoc-textfield
                            size="small"
                            variant="outline"
                            class={
                              showWarnings && _.isEmpty(block) ? "warning" : ""
                            }
                          >
                            <input
                              type="text"
                              value={block}
                              onChange={(e) => addFileTypesHandler(e, index)}
                            />
                          </viedoc-textfield>
                          <viedoc-icon
                            title={t("ADMIN.TEXT_REMOVE")}
                            name="remove"
                            onClick={() => removeFileTypeshandler(index)}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </Fragment>
            ))}
            <div className="d-flex pad-10 align-center">
              <div className="w-25 text-right pr-10 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_DATINGCONVENTION")}
                {spanFunc()}
              </div>
              <div className="w-450 tmfside-checkbox">
                <ViedocSelectElement
                  size="small"
                  value={selectedDatingConvention}
                  onChange={(e) => {
                    setSelectedDatingConvention(e.target.value);
                  }}
                >
                  {datingConventionList.map((dating) => (
                    <ViedocMenuItemElement key={dating.id} value={dating.name}>
                      {dating.name}
                    </ViedocMenuItemElement>
                  ))}
                </ViedocSelectElement>
                {selectedDatingConvention === APP_CONST.TEXT_NEW && (
                  <div className="mt-10">
                    <viedoc-textfield
                      class="disabled_input"
                      size="small"
                      variant="outline"
                    >
                      <input
                        type="text"
                        value={newDatingConvention}
                        onChange={(e) => setNewDatingConvention(e.target.value)}
                      />
                    </viedoc-textfield>
                  </div>
                )}
              </div>
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const detailsSectionArray = [
    {
      id: 1,
      mainLabel: t("ADMIN.ADMINTAB_DETAILS"),
      radioLabel1: t("ARCHIVE.FORMLABEL_STANDARD"),
      radioLabel2: t("ARCHIVE.FORMLABEL_ONLYFILENAMEEXTENSIONS"),
      type: "Details",
      location1: "Standard",
      location2: "Only filename extensions",
      checked1: detailsValue === "*",
      checked2: detailsValue !== "*",
      isRequired: true,
    },
    {
      id: 2,
      mainLabel: t("ADMIN.ADMINTAB_BLINDEDDATA"),
      radioLabel1: t("ADMIN.TEXT_ACCEPTED"),
      radioLabel2: t("ADMIN.TEXT_NOTACCEPTED"),
      location1: "Accepted",
      location2: "Not accepted",
      type: "Blinded data",
      checked1: blindedData === "ACCEPTED",
      checked2: blindedData === "NOT ACCEPTED",
      isRequired: true,
    },
    {
      id: 3,
      mainLabel: t("ADMIN.ADMINTAB_PRIVACYDATA"),
      radioLabel1: t("ADMIN.TEXT_ACCEPTED"),
      radioLabel2: t("ADMIN.TEXT_NOTACCEPTED"),
      location1: "Accepted",
      location2: "Not accepted",
      type: "Privacy data",
      checked1: privacyData === "ACCEPTED",
      checked2: privacyData === "NOT ACCEPTED",
      isRequired: true,
    },
  ];

  const checkEmptySubArtifactsAndFileFormats = (first, second, skip) => {
    if (_.isEmpty(first) && !skip) {
      return true;
    }

    for (let i = 0; i < second.length; i++) {
      if (_.isEmpty(second[i])) {
        return true;
      }
    }
    return false;
  };
  const saveChangesHandler = () => {
    let ModifiedDateValue = zoneData.filter(
      (data) => data.origid === artifactDetails?.zoneId
    );
    let trailUserRoleAccess = trialDocument !== APP_CONST.TEXT_NOT_PERMITTED ? trialRolesAndAccessPayload : [];
    let countryUserRoleAccess = countryDocument !== APP_CONST.TEXT_NOT_PERMITTED ? countryRolesAndAccessPayload : [];
    let siteUserRoleAccess = siteDocument !== APP_CONST.TEXT_NOT_PERMITTED ? siteRolesAndAccessPayload : [];
    let modifiedDate = "";
    if (ModifiedDateValue && !_.isEmpty(ModifiedDateValue)) {
      modifiedDate = ModifiedDateValue[0].recentModifiedOn;
    }
    let requestPayload = {
      lastmodifiedon:
        modifiedDate ||
        artifactDetails?.lastmodifiedon ||
        tmfStructureData?.lastmodifiedon,
      zone: {
        id: artifactDetails.zoneId,
      },
      section: {
        id: artifactDetails.sectionId,
      },
      artifact: {
        id: classification.artifactid,
        name: artifactName,
        definition: definition,
        subArtifacts: subArtifactPayload.map((subArts) => {
          return {
            name: subArts,
            islinkshared: false,
          };
        }),
        isartifactlinkshared: isArtifactLinkShared,
        uniqueIdNumber: uniqueId,
        applicableInTrial: trialDocument,
        applicableInCountry: countryDocument,
        applicableAtSite: siteDocument,
        sponsorDocument: isSponsor,
        investigatorDocument: isInvestigator,
        artifactUserAccess: [
          ...trailUserRoleAccess,
          ...countryUserRoleAccess,
          ...siteUserRoleAccess,
        ],
        trialLevelMilestone: trialMilestone || "",
        countryLevelMilestone: countryMilestone || "",
        siteLevelMilestone: siteMilestone || "",
        fileFormats:
          detailsValue === "*"
            ? [detailsValue]
            : [fileFormats, ...addSupportedFilesTypes],
        acceptBlindedData: blindedData === "ACCEPTED",
        acceptPrivacyData: privacyData === "ACCEPTED",
        datingConvention:
          selectedDatingConvention === APP_CONST.TEXT_NEW
            ? newDatingConvention
            : selectedDatingConvention,
      },
      sharing: {
        artifactid: sharing?.artifactid || classification.artifactid,
        clinicaluser: {
          enable: clinicalUserChecked || false,
        },
        subjectuser: {
          enable: viedocMeUserChecked || false,
        },
      },
    };

    if (_.isEmpty(artifactName) || _.isEmpty(definition)) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      requestPayload.artifact.applicableAtSite !== "Not permitted" &&
      _.isEmpty(requestPayload.artifact.siteLevelMilestone)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      requestPayload.artifact.applicableInTrial !== "Not permitted" &&
      _.isEmpty(requestPayload.artifact.trialLevelMilestone)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      requestPayload.artifact.applicableInCountry !== "Not permitted" &&
      _.isEmpty(requestPayload.artifact.countryLevelMilestone)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      checkEmptySubArtifactsAndFileFormats(subArtifact, addSubartifact, true) ||
      (checkEmptySubArtifactsAndFileFormats(
        fileFormats,
        addSupportedFilesTypes
      ) &&
        detailsValue !== "*")
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else {
      setShowToaster(false);
      setShowWarnings(false);
      dispatch(templateActions.addNewArtifact(requestPayload));
      setInitialLoad(false);
      setIsTouched(false);
    }
  };

  const renderToaster = (message) => {
    return (
      showToaster && (
        <viedoc-toaster
          onClick={() => setShowToaster(false)}
          variant="error"
          prefix-icon="warning"
          toasterMsg={message}
        ></viedoc-toaster>
      )
    );
  };

  return (
    <ViedocDialogElement
      size="large"
      open
      preventCloseByClick
      class="edit-artifact-popup"
      onHide={() => onHide()}
    >
      <header className="pl-10" slot="header">
        <p className="f21 mt-5">{t("ADMIN.TEXT_EDITARTIFACT")}</p>
        {!isEditLoading && (
          <div className="header-button">
            <ViedocButtonElement
              size="small"
              variant="neutral"
              disabled={!isTouched}
              onClick={() => saveChangesHandler()}
              title={t("ADMIN.BUTTON_SAVEBTN")}
            >
              {t("ADMIN.BUTTON_SAVEBTN")}
            </ViedocButtonElement>
          </div>
        )}
      </header>
      {viewLoading || isEditLoading ? (
        <Loader width={"100%"} height={"100%"} borderRadius />
      ) : (
        <Fragment>
          {renderToaster(artifactFail ? artifactFail : t("TMF.TOAST_REQUIRED"))}
          <div className="sub-header">
            <div className="icon-block">
              <viedoc-icon name="folder"></viedoc-icon>
              <p className="f24">{classification?.artifactname}</p>
            </div>

            <p className="f14 gray-60 ml-70 ff-vmg">
              {`${t(
                "ADMIN.TEXT_FROMTEMPLATE"
              )} ${UtilsHelper.fileExtensionRemoval(filename || "")}`}
            </p>
          </div>
          <div className="bb-2 w-100"></div>
          {renderClassificationSection()}
          <div className="bb-2 w-100"></div>
          <LocationLevelSetting
            label={`${t("ADMIN.TEXT_TRIAL")} ${t("ADMIN.TEXT_LEVELSETTINGS")}`}
            type="trial"
            locationArray={trialLevelDocument}
            settingsObject={triallevelsetting}
            sendRolesAndAccessData={sendRolesAndAccessData}
            sendMilestone={sendMilestone}
            sendDocument={sendDocument}
            showWarnings={showWarnings}
            RadioFieldRequired = {trialDocument === APP_CONST.TEXT_REQUIRED ? true : false}
            RadioFieldOPtional = {trialDocument === APP_CONST.TEXT_OPTIONAL ? true : false}
            RadioFieldNotPermitted = {trialDocument === APP_CONST.TEXT_NEW ? true : false}
            selectedMilestoneValue = {trialMilestone}
            selectedRolesAndAccess = {trialRolesAndAccessPayload}
          />
          <div className="bb-2 w-100"></div>
          <LocationLevelSetting
            label={`${t("ADMIN.TEXT_COUNTRYLBL")} ${t(
              "ADMIN.TEXT_LEVELSETTINGS"
            )}`}
            type="country"
            locationArray={countryLevelDocument}
            settingsObject={countrylevelsetting}
            sendRolesAndAccessData={sendRolesAndAccessData}
            sendMilestone={sendMilestone}
            sendDocument={sendDocument}
            showWarnings={showWarnings}
            RadioFieldRequired = {countryDocument === APP_CONST.TEXT_REQUIRED ? true : false}
            RadioFieldOPtional = {countryDocument === APP_CONST.TEXT_OPTIONAL ? true : false}
            RadioFieldNotPermitted = {countryDocument === APP_CONST.TEXT_NEW ? true : false}
            selectedMilestoneValue = {countryMilestone}
            selectedRolesAndAccess = {countryRolesAndAccessPayload}
          />
          <div className="bb-2 w-100"></div>
          <LocationLevelSetting
            label={`${t("ADMIN.TEXT_SITELBL")} ${t(
              "ADMIN.TEXT_LEVELSETTINGS"
            )}`}
            type="site"
            locationArray={siteLevelDocument}
            settingsObject={sitelevelsetting}
            sendRolesAndAccessData={sendRolesAndAccessData}
            sendMilestone={sendMilestone}
            sendDocument={sendDocument}
            showWarnings={showWarnings}
            RadioFieldRequired = {siteDocument === APP_CONST.TEXT_REQUIRED ? true : false}
            RadioFieldOPtional = {siteDocument === APP_CONST.TEXT_OPTIONAL ? true : false}
            RadioFieldNotPermitted = {siteDocument === APP_CONST.TEXT_NEW ? true : false}
            selectedMilestoneValue = {siteMilestone}
            selectedRolesAndAccess = {siteRolesAndAccessPayload}
          />

          <div className="bb-2 w-100"></div>
          {renderDetailsSection()}
          <div className="bb-2 w-100"></div>
          {renderSharingSection()}
          <div className="mb-20"></div>
        </Fragment>
      )}
      <footer slot="footer"></footer>
    </ViedocDialogElement>
  );
};

export default EditArtifactPopUp;
